var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@mui/material';
import { Typography } from '../utils/Typography';
export var Title = function (_a) {
    var _b = _a.widthSidebard, widthSidebard = _b === void 0 ? 0 : _b, _c = _a.isWhite, isWhite = _c === void 0 ? false : _c;
    var width = 150;
    var sx = {
        width: "".concat(width, "px"),
        padding: '0px 40px',
        marginTop: '9px',
    };
    if (widthSidebard) {
        sx.position = 'absolute';
        sx.left = "calc(50% - ".concat(width / 2, "px + ").concat(widthSidebard / 2, "px)");
    }
    if (isWhite) {
        sx.filter = 'brightness(10)';
    }
    return (_jsx(Stack, __assign({ sx: sx }, { children: _jsx("img", { src: "/name.svg" }) })));
    return (_jsxs(Stack, __assign({ direction: "row", className: "pb-small", justifyContent: "center" }, { children: [_jsx(Typography, __assign({ className: "bold", variant: "h3", sx: { color: 'header.main' } }, { children: "G" })), _jsx(Typography, __assign({ className: "bold", variant: "h3", sx: { color: 'client.main' } }, { children: "A" })), _jsx(Typography, __assign({ className: "bold", variant: "h3", sx: { color: 'affaire.main' } }, { children: "E" })), _jsx(Typography, __assign({ className: "bold", variant: "h3", sx: { color: 'activite.main' } }, { children: "L" })), _jsx(Typography, __assign({ className: "bold", variant: "h3", sx: { color: 'collaborateur.main' } }, { children: "I" }))] })));
};
//# sourceMappingURL=Title.js.map